import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3800929241/src/src/app/ui/common/server-error-forwarder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3800929241/src/src/app/ui/poi-detail/poi-detail-images.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3800929241/src/src/app/ui/poi-detail/poi-detail-info-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3800929241/src/src/app/ui/poi-detail/poi-detail-top-bar.tsx");
